"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueByCurrency = void 0;
const src_1 = require("..");
function getValueByCurrency(value, currencyCode) {
    if (!currencyCode) {
        return value.toString();
    }
    switch (currencyCode) {
        case 'DJF':
        case 'BIF':
        case 'GNF':
        case 'KMF':
        case 'MGA':
        case 'VUV':
        case 'XOF':
        case 'CLP':
        case 'PYG':
        case 'RWF':
        case 'UGX':
        case 'VND':
        case 'KRW':
        case 'XPF':
        case 'HUF':
        case 'TWD':
        case 'JPY':
            return (0, src_1.getFormattedValue)(value, 0, '', '');
        // TODO: Explore the possibility of using Intl.NumberFormat browser functionality instead.
        default:
            return (0, src_1.getFormattedValue)(value, 2, '.', '');
        // TODO: Explore the possibility of using Intl.NumberFormat browser functionality instead.
    }
}
exports.getValueByCurrency = getValueByCurrency;
